import React, { Component } from "react";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import ItemMasterServices from "../../services/axioServices/apiServices/ItemMasterServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import ProductionServices from "../../services/axioServices/apiServices/ProductionServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { GetAllProductionBatchRegister } from "../../services/axioServices/ApiEndPoints.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";
import { printFunction } from "../../components/print/printTemplate.js";

class ProductCostingReport extends Component {
  constructor(props) {
    super(props);
    this.itemMasterServices = new ItemMasterServices();
    this.commonServices = new CommonServices();
    this.productionServices = new ProductionServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      isEditingKeyForRM: null,
      isEditingKeyForPM: null,
      productDropdownList: [],
      companyItemList: [],
      rmFormulaList: [],
      pmFormulaList: [],
      totalRMFormula: 0,
      isLoading: false,
      tableStatus: "",
      productDetails: {
        productId: "",
        productName: '',
        packingId: "",
        packing: "",
        unitQty: 0,
        btSize: "",
        size: "",
        color: "",
        RMtotal: "",
        PMtotal: "",
        totalRmPm: 0,
        prodLoss: 0,
        calProdLoss: 0,
        totalBatchCost: 0,
        perUnitCost: 0,
        jobCharges: 0,
        margin: 0,
        calMargin: 0,
        testingCharges: "",
        otherCharges: 200,
        calOtherCharges: "",
        netBatchCost: "",
        calNetBatchCost: "",
        itemMasterRate: "",
      },
      validationRules: {
        productId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        packingId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "packing"
            ),
          },
        ],
        btSize: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch size"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    this.getAllProductDropdown();
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }

  getAllProductDropdown = () => {
    this.commonServices.getAllProductDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.productName,
          value: item._id,
        }));
        this.setState({ productDropdownList: dropdownItems }, () => {
          this.getAllItem();
        });
      } else {
        this.getAllItem();
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
          unitQty: item.UnitQuantity,
          jobCharge: item.JobCharge,
          testingcharge: item.TestingCharge,
          prodLoss: item.ProdLoss,
          basicRate: item.BasicRate,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.productDetails;
    if (name === "prodLoss" || name === "margin" || name === "otherCharges") {
      details[name] = value;
      details.calProdLoss = (
        Number(details.totalRmPm) *
        ((details.prodLoss > 0 ? details.prodLoss : 0) / 100)
      ).toFixed(2);
      details.totalBatchCost = (
        Number(details.totalRmPm) + Number(details.calProdLoss)
      ).toFixed(2);
      details.perUnitCost = (
        Number(details.totalBatchCost) /
        (Number(details.btSize) /
          (Number(details.unitQty) > 0 ? Number(details.unitQty) : 1))
      ).toFixed(2);
      details.calMargin = (
        (Number(details.perUnitCost) + Number(details.jobCharges)) *
        (Number(details.margin) / 100)
      ).toFixed(2);
      details.calOtherCharges = (
        Number(details.otherCharges) /
        (Number(details.btSize) /
          (Number(details.unitQty) > 0 ? Number(details.unitQty) : 1))
      ).toFixed(2);
      details.netBatchCost = details.packing;
      details.calNetBatchCost = (
        Number(details.perUnitCost) +
        Number(details.calMargin) +
        Number(details.jobCharges) +
        Number(details.testingCharges) +
        Number(details.calOtherCharges)
      ).toFixed(2);
    } else {
      details[name] = value.toUpperCase();
    }
    this.setState({ productDetails: details });
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.productDetails;
    details[drpIdentity] = selected.value;
    if (drpIdentity === "productId") {
      details.productName = selected.label
      this.getProductDetailById(this.state.productDetails.productId);
    }
    if (drpIdentity === "packingId") {
      details.packing = selected.packing;
      details.unitQty = selected.unitQty;
      details.jobCharges = Number(selected.jobCharge).toFixed(2);
      details.prodLoss = Number(selected.prodLoss).toFixed(2);
      details.testingCharges = Number(selected.testingcharge).toFixed(2);
      details.itemMasterRate = Number(selected.basicRate).toFixed(2);
    }
    this.setState({ productDetails: details });
  };

  getProductDetailById = (id) => {
    this.itemMasterServices.getProductDetailById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let details = this.state.productDetails;
        details.size = res.sizeName;
        details.color = res.color;
        this.setState({ productDetails: details });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };

  searchProductCostingReport = () => {
    let isValidAllFields = this.isValidAllFields();
    if (isValidAllFields) {
      this.setState({ isLoading: true, tableStatus: "Loading..." }, () => {
        let request = this.state.productDetails;
        this.productionServices
          .getProductCostingReport(request)
          .then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
              if (response.responseData.length === 0) {
                this.setState({ tableStatus: "No Record Found" })
              } else {
                this.setState({ tableStatus: "" })
              }
              let res = response.responseData;
              let rmFormulaList = res.rmFormulaList;

              rmFormulaList = rmFormulaList.map((item) => {
                let convertedQty = this.convertNetQty(
                  item.netQty,
                  item.uom,
                  item.rmId?.rmUOM
                );
                item.convertedQty = (
                  convertedQty * Number(this.state.productDetails.btSize)
                ).toFixed(3);
                item.purchaseRate = (
                  item.isGrnRecord
                    ? Number(item.grnRate)
                    : Number(item?.rmId?.rmPurchaseRate)
                ).toFixed(3);
                item.lastPurchaseDate = item.isGrnRecord
                  ? moment(item.lastPurchaseDate).format("DD MMM yyyy")
                  : "";
                item.totalAmount =
                  Number(item.convertedQty) * Number(item.purchaseRate);
                return item;
              });

              let pmFormulaList = res.pmFormulaList;
              pmFormulaList = pmFormulaList.map((item) => {
                item.netQty = Number(item.netQty) / Number(item.batchSize);
                item.convertedQty = (
                  Number(item.netQty) * Number(this.state.productDetails.btSize)
                ).toFixed(3);
                item.purchaseRate = (
                  item.isGrnRecord
                    ? Number(item.grnRate)
                    : Number(item?.packageMaterialId?.pmPurchaseRate)
                ).toFixed(3);
                item.lastPurchaseDate = item.isGrnRecord
                  ? moment(item.lastPurchaseDate).format("DD MMM yyyy")
                  : "";
                item.totalAmount =
                  Number(item.convertedQty) * Number(item.purchaseRate);
                return item;
              });

              this.setState(
                { rmFormulaList: rmFormulaList, pmFormulaList: pmFormulaList },
                () => {
                  this.calculateQtyandRate()
                }
              );
            } else {
              this.setState({ tableStatus: "", isLoading: false })
              this.SwalServices.Error(
                response.Message
              );
            }
          });
      })
    }
  };

  calculateQtyandRate = () => {
    let details = this.state.productDetails;
    let totalRMFormula = this.state.rmFormulaList.reduce(
      (accumulator, item) => {
        return accumulator + item.totalAmount;
      },
      0
    );
    let totalPMFormula = this.state.pmFormulaList.reduce(
      (accumulator, item) => {
        return accumulator + item.totalAmount;
      },
      0
    );
    let totalRMPM = totalRMFormula + totalPMFormula;

    details.RMtotal = totalRMFormula.toFixed(3);
    details.PMtotal = totalPMFormula.toFixed(3);
    details.totalRmPm = totalRMPM.toFixed(3);
    details.calProdLoss = (
      details.totalRmPm *
      ((details.prodLoss > 0 ? details.prodLoss : 0) / 100)
    ).toFixed(2);
    details.totalBatchCost = (
      Number(details.totalRmPm) + Number(details.calProdLoss)
    ).toFixed(2);
    details.perUnitCost = (
      Number(details.totalBatchCost) /
      (Number(details.btSize) /
        (Number(details.unitQty) > 0 ? Number(details.unitQty) : 1))
    ).toFixed(2);
    details.calMargin = (
      (Number(details.perUnitCost) + Number(details.jobCharges)) *
      (Number(details.margin) / 100)
    ).toFixed(2);
    details.calOtherCharges = (
      Number(details.otherCharges) /
      (Number(details.btSize) /
        (Number(details.unitQty) > 0 ? Number(details.unitQty) : 1))
    ).toFixed(2);
    details.netBatchCost = details.packing;
    details.calNetBatchCost = (
      Number(details.perUnitCost) +
      Number(details.calMargin) +
      Number(details.jobCharges) +
      Number(details.testingCharges) +
      Number(details.calOtherCharges)
    ).toFixed(2);
    this.setState({ productDetails: details, isLoading: false });
  }

  convertNetQty = (netQty, uom, rmUOM) => {
    if (uom === rmUOM) {
      return netQty;
    }

    if (uom === "MCG") {
      if (rmUOM === "KGS") {
        return netQty / 1000000000;
      }
      if (rmUOM === "GM") {
        return netQty / 1000000;
      }
      if (rmUOM === "MG") {
        return netQty / 1000;
      }
    }

    if (uom === "GM") {
      if (rmUOM === "KGS") {
        return netQty / 1000;
      }
      if (rmUOM === "MG") {
        return netQty * 1000;
      }
    }

    if (uom === "MG") {
      if (rmUOM === "KGS") {
        return netQty / 1000000;
      }
      if (rmUOM === "GM") {
        return netQty / 1000;
      }
    }

    if (uom === "KGS") {
      if (rmUOM === "MG") {
        return netQty * 1000000;
      }
      if (rmUOM === "GM") {
        return netQty * 1000;
      }
    }
    if (uom === "LTR") {
      return netQty * 1000;
    }

    if (uom === "ML") {
      return netQty / 1000;
    }
    return netQty;
  };

  isValidAllFields = () => {
    const newValidState = isValidForm(
      this.state.productDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  handleQtyChangeForRM = (event, index, name) => {
    let value = event.target.value;
    let list = [...this.state.rmFormulaList];
    list[index] = { ...list[index], [name]: value };
    this.setState({ rmFormulaList: list }, () => {

      let rmFormulaList = this.state.rmFormulaList.map((item) => {
        item.totalAmount = Number(item.convertedQty) * Number(item.purchaseRate);
        return item;
      });
      this.setState({ rmFormulaList: rmFormulaList }, () => {
        this.calculateQtyandRate()
      })
    });
  }

  handleQtyChangeForPM = (event, index, name) => {
    let value = event.target.value;
    let list = [...this.state.pmFormulaList];
    list[index] = { ...list[index], [name]: value };
    this.setState({ pmFormulaList: list }, () => {

      let pmFormulaList = this.state.pmFormulaList.map((item) => {
        item.totalAmount = Number(item.convertedQty) * Number(item.purchaseRate);
        return item;
      });
      this.setState({ pmFormulaList: pmFormulaList }, () => {
        this.calculateQtyandRate()
      })
    });
  }

  render() {
    return (
      <div className="productCostingReport-page ">
        {/* 1. Item serach  */}
        <div className="item-search !mb-[10px]">
          {/* Row - 1  */}
          <div className="item-grp flex gap-2.5 mb-[8px]">
            <div className="search-grp  w-full">
              <label>Product Name</label>

              <MultiSelectDropdown
                drpIdentity="productId"
                options={this.state.productDropdownList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                className={`inputFocus ${this.state.validState?.error?.productId ? "errorInput" : ""}`}
                onChange={(selected) =>
                  this.setFilterParameters(
                    selected,
                    "productId",
                    "productDetails"
                  )
                }
                allowSelectAll={false}
                value={this.state.productDropdownList.filter(
                  (party) => party.value === this.state.productDetails.productId
                )}
              />
              {/* <ValidationText error={this.state.validState.error.productId} /> */}
            </div>

            <div className="search-grp  w-full">
              <label>Packing</label>
              <MultiSelectDropdown
                drpIdentity="packingId"
                options={this.state.companyItemList}
                closeMenuOnSelect={true}
                className={`inputFocus ${this.state.validState?.error?.packingId ? "errorInput" : ""}`}
                hideSelectedOptions={false}
                onChange={(selected) =>
                  this.setFilterParameters(
                    selected,
                    "packingId",
                    "productDetails"
                  )
                }
                allowSelectAll={false}
                value={this.state.companyItemList.filter(
                  (party) => party.value === this.state.productDetails.packingId
                )}
              />
              {/* <ValidationText error={this.state.validState.error.      className={`inputFocus ${this.state.validState?.error?.ItemName ? "errorInput" : ""}`}} /> */}
            </div>
            <div className="search-grp w-[40%]">
              <label>Bt. Size</label>
              <input
                type="number"
                id="btSize"
                name="btSize"
                autoComplete="off"
                className={`inputFocus ${this.state.validState?.error?.btSize ? "errorInput" : ""}`}
                value={this.state.productDetails.btSize}
                onChange={(event) =>
                  this.handleChange(event, "btSize", "productDetails")
                }
              />
              {/* <ValidationText error={this.state.validState.error.btSize} /> */}
            </div>
          </div>
          {/* Row - 2 */}
          <div className="item-grp flex gap-2.5 ">
            <div className="search-grp basis-[25%]">
              <label>Packing</label>
              <input
                type="text"
                id="packing"
                name="packing"
                autoComplete="off"
                className="inputFocus w-full disable-input"
                value={this.state.productDetails.packing}
                onChange={(event) =>
                  this.handleChange(event, "packing", "productDetails")
                }
                disabled
              />
            </div>
            <div className="search-grp  basis-[25%]">
              <label>Size</label>
              <input
                type="text"
                id="size"
                name="size"
                autoComplete="off"
                className="inputFocus w-full disable-input"
                value={this.state.productDetails.size}
                onChange={(event) =>
                  this.handleChange(event, "size", "productDetails")
                }
                disabled
              />
            </div>
            <div className="search-grp  basis-[25%]">
              <label>color</label>
              <input
                type="text"
                id="color"
                name="color"
                autoComplete="off"
                className="inputFocus w-full disable-input"
                value={this.state.productDetails.color}
                onChange={(event) =>
                  this.handleChange(event, "color", "productDetails")
                }
                disabled
              />
            </div>
            <div className="reportBtn-grp flex gap-2.5 mt-auto">
              <button
                className="search-btn mt-auto"
                onClick={() => {
                  this.searchProductCostingReport();
                }}
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Search"}
              </button>
              {this.state.rmFormulaList.length > 0 ||
                this.state.pmFormulaList.length > 0 ? (
                <button
                  className="print-btn mt-3.5"
                  onClick={() => printFunction()}
                  disabled={this.state.isLoading}
                >
                  Print
                </button>
              ) : null}
            </div>

          </div>
        </div>

        {/* 2. Table & Sections  */}
        <div className="flex gap-4">
          <div className="hidden print-title print:mb-2">
            <div className="w-full">
              <table className="no-border">
                <tbody>
                  <tr>
                    <td className="no-padding">
                      <h4>Production Costing Report</h4>
                    </td>
                    <td className="no-padding">
                      <p className="end">Date:- {moment().format('DD-MM-YYYY')}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-black"><span>Item name:- {this.state.productDetails.productName}</span>, <span>Batch Size:- {this.state.productDetails.btSize}</span>, </p>
          </div>
          {/* 1 - Table  */}
          <div className="itemList-table w-full ">
            <div className="itemList-inner print:break-after-page">
              <div className="table-container print:h-fit print:overflow-hidden h-[38vh] overflow-y-scroll ">
                <table className="itemList">
                  <thead className="print:!relative print:!shadow-none">
                    <tr className=" print:border print:border-[#ddd] print:border-b-0">
                      <td className="w-[26%] print-w-40 print:text-slate-950 print:border print:border-[#e5e7eb]">Material Name</td>
                      <td className="w-[14%] no-print print:text-slate-950 print:border print:border-[#e5e7eb]">L.p. Date</td>
                      <td className="w-[18%] print-w-15 print:text-slate-950 print:border print:border-[#e5e7eb]">Quantity</td>
                      <td className="w-[10%] print-w-12 print:text-slate-950 print:border print:border-[#e5e7eb]">U.O.M</td>
                      <td className="w-[16%] print-w-18 print:text-slate-950 print:border print:border-[#e5e7eb]">Rate</td>
                      <td className="w-[6%] print-w-8 print:text-slate-950 print:border print:border-[#e5e7eb]">Test</td>
                      <td className="w-[10%] print-w-7 print:text-slate-950 print:border print:border-[#e5e7eb]">Amount</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.rmFormulaList &&
                      this.state.rmFormulaList.length > 0
                      ? this.state.rmFormulaList.map((item, key) => (
                        <tr key={key}>
                          <td>{item?.rmId?.rmName}</td>
                          <td className="no-print">{item.lastPurchaseDate}</td>
                          <td className="cursor-pointer">
                            {this.state.isEditingKeyForRM === key ? (
                              <div class="flex items-center space-x-2">
                                <input
                                  className="inputFocus"
                                  type="number"
                                  id="convertedQty"
                                  name="convertedQty"
                                  autoComplete="off"
                                  class="h-7 w-[80%] px-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  value={item.convertedQty}
                                  onChange={(event) => this.handleQtyChangeForRM(event, key, 'convertedQty')} />
                                <button
                                  class="h-7 px-2 bg-sky-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  onClick={() => this.setState({ isEditingKeyForRM: null }, () => this.forceUpdate())}
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                              </div>
                            ) :
                              <div onClick={() => this.setState({ isEditingKeyForRM: key })}>
                                {item.convertedQty}
                              </div>
                            }
                          </td>
                          <td>{item?.rmId?.rmUOM}</td>
                          <td className="cursor-pointer">
                            {this.state.isEditingKeyForRM === key ? (
                              <div class="flex items-center space-x-2">
                                <input
                                  className="inputFocus"
                                  type="number"
                                  id="purchaseRate"
                                  name="purchaseRate"
                                  autoComplete="off"
                                  class="h-7 w-[80%] px-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  value={item.purchaseRate}
                                  onChange={(event) => this.handleQtyChangeForRM(event, key, 'purchaseRate')} />
                                <button
                                  class="h-7 px-2 bg-sky-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  onClick={() => this.setState({ isEditingKeyForRM: null }, () => this.forceUpdate())}
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                              </div>
                            )
                              :
                              <div onClick={() => this.setState({ isEditingKeyForRM: key })}>
                                {item.purchaseRate}
                              </div>
                            }
                            {/* {Number(item?.purchaseRate)} */}
                          </td>
                          <td>{item?.rmId?.testingCharge}</td>
                          <td className="print:text-right">{item.totalAmount.toFixed(2)}</td>
                        </tr>
                      ))
                      : this.state.rmFormulaList &&
                        this.state.rmFormulaList.length === 0
                        && this.state.tableStatus !== "" ? (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                            {this.state.tableStatus}
                          </td>
                        </tr>
                      ) : this.state.rmFormulaList &&
                        this.state.rmFormulaList.length === 0
                        && this.state.tableStatus === "" ? null : ""}
                    <tr className="last-row hidden">
                      <td className="end" colSpan={6}>R.M. Total</td>
                      <td className="text-[14px] font-bold text-[#585858] print:text-right">{this.state.productDetails.RMtotal}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="search-grp flex justify-end gap-2.5 mt-3 mb-3 no-print">
                <div className="flex justify-end items-center text-[14px] font-medium text-[#585858]">R.M. Total</div>
                <input
                  className="inputFocus w-[30%]"
                  type="number"
                  id="RMtotal"
                  name="RMtotal"
                  autoComplete="off"
                  disabled
                  value={this.state.productDetails.RMtotal}
                  onChange={(event) =>
                    this.handleChange(event, "RMtotal", "productDetails")
                  }
                />
              </div>
            </div>
            <div className="itemList-inner print:break-after-page">
              <div className="table-container print:h-fit print:overflow-hidden h-[20vh] overflow-y-scroll">
                <table className="itemList">
                  <thead className="print:!relative print:!shadow-none">
                    <tr className="print:border print:border-[#ddd] print:border-b-0">
                      <td className="w-[26%] print-w-40 print:text-slate-950">Material Name</td>
                      <td className="w-[14%] no-print print:text-slate-950">L.p. Date</td>
                      <td className="w-[18%] print-w-15 print:text-slate-950">Quantity</td>
                      <td className="w-[10%] print-w-12 print:text-slate-950">U.O.M</td>
                      <td className="w-[16%] print-w-18 print:text-slate-950">Rate</td>
                      <td className="w-[6%] print-w-8 print:text-slate-950">Test</td>
                      <td className="w-[10%] print-w-7 print:text-slate-950">Amount</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.pmFormulaList &&
                      this.state.pmFormulaList.length > 0
                      ? this.state.pmFormulaList.map((item, key) => (
                        <tr key={key}>
                          <td>{item?.packageMaterialId?.pmName}</td>
                          <td className="no-print">{item.lastPurchaseDate}</td>
                          <td className="cursor-pointer">
                            {this.state.isEditingKeyForPM === key ? (
                              <div class="flex items-center space-x-2">
                                <input
                                  className="inputFocus"
                                  type="number"
                                  id="convertedQty"
                                  name="convertedQty"
                                  autoComplete="off"
                                  class="h-7 w-[80%] px-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  value={item.convertedQty}
                                  onChange={(event) => this.handleQtyChangeForPM(event, key, 'convertedQty')} />
                                <button
                                  class="h-7 px-2 bg-sky-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  onClick={() => this.setState({ isEditingKeyForPM: null }, () => this.forceUpdate())}
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                              </div>
                            ) :
                              <div onClick={() => this.setState({ isEditingKeyForPM: key })}>
                                {item.convertedQty}
                              </div>
                            }
                          </td>
                          <td>{item?.packageMaterialId?.pmUOM}</td>
                          <td className="cursor-pointer">
                            {this.state.isEditingKeyForPM === key ? (
                              <div class="flex items-center space-x-2">
                                <input
                                  className="inputFocus"
                                  type="number"
                                  id="purchaseRate"
                                  name="purchaseRate"
                                  autoComplete="off"
                                  class="h-7 w-[80%] px-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  value={item.purchaseRate}
                                  onChange={(event) => this.handleQtyChangeForPM(event, key, 'purchaseRate')} />
                                <button
                                  class="h-7 px-2 bg-sky-600 text-white rounded hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-sky-500"
                                  onClick={() => this.setState({ isEditingKeyForPM: null }, () => this.forceUpdate())}
                                >
                                  <FontAwesomeIcon icon={faCheck} />
                                </button>
                              </div>
                            )
                              :
                              <div onClick={() => this.setState({ isEditingKeyForPM: key })}>
                                {item.purchaseRate}
                              </div>
                            }
                          </td>
                          <td>{item?.packageMaterialId?.pmTestingCharge}</td>
                          <td>{item.totalAmount.toFixed(2)}</td>
                        </tr>
                      ))
                      : this.state.pmFormulaList &&
                        this.state.pmFormulaList.length === 0
                        && this.state.tableStatus !== "" ? (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                            {this.state.tableStatus}
                          </td>
                        </tr>
                      ) : this.state.pmFormulaList &&
                        this.state.pmFormulaList.length === 0
                        && this.state.tableStatus === "" ? null : ""}
                    <tr className="last-row hidden">
                      <td className="end" colSpan={6}>P.M. Total</td>
                      <td className="text-[14px] font-bold text-[#585858] print:text-right">{this.state.productDetails.PMtotal}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="search-grp flex justify-end gap-2.5 mt-3 mb-3 no-print">
                <div className="flex justify-end items-center text-[14px] font-medium text-[#585858]">P.M. Total</div>
                <input
                  className="inputFocus w-[30%]"
                  type="number"
                  id="PMtotal"
                  name="PMtotal"
                  autoComplete="off"
                  disabled
                  value={this.state.productDetails.PMtotal}
                  onChange={(event) =>
                    this.handleChange(event, "PMtotal", "productDetails")
                  }
                />
              </div>
            </div>
          </div>
          <span className=' border-l-2'></span>
          <div className="total-table hidden costing-total">
            <table>
              <tbody>
                <tr>
                  <td className="print-w-70">Total RM+PM Amount</td>
                  <td className="print-w-30">{this.state.productDetails.totalRmPm}</td>
                </tr>
                <tr>
                  <td className="print-w-70">Prod. loss - ({this.state.productDetails.prodLoss}%)</td>
                  <td className="print-w-30">{this.state.productDetails.calProdLoss}</td>
                </tr>
                <tr>
                  <td className="print-w-70">Total Batch Cost</td>
                  <td className="print-w-30">{this.state.productDetails.totalBatchCost}</td>
                </tr>
                <tr>
                  <td className="print-w-70">Per Unit Cost</td>
                  <td className="print-w-30">{this.state.productDetails.perUnitCost}</td>
                </tr>
                <tr>
                  <td className="print-w-70">Mfg. Job Charges</td>
                  <td className="print-w-30">{this.state.productDetails.jobCharges}</td>
                </tr>
                <tr>
                  <td className="print-w-70">Margin - ({this.state.productDetails.margin}%)</td>
                  <td className="print-w-30">{this.state.productDetails.calMargin}</td>
                </tr>
                <tr>
                  <td className="print-w-70">FP - Testing Charges</td>
                  <td className="print-w-30">{this.state.productDetails.testingCharges}</td>
                </tr>
                <tr>
                  <td className="print-w-70">Other Charges - ({this.state.productDetails.otherCharges}%)</td>
                  <td className="print-w-30">{this.state.productDetails.calOtherCharges}</td>
                </tr>
                <tr>
                  <td className="print-w-70 print:!font-semibold"><strong>Net Product Cost ({this.state.productDetails.netBatchCost})</strong></td>
                  <td className="print-w-30 print:!font-semibold"><strong>{this.state.productDetails.calNetBatchCost}</strong></td>
                </tr>
                {/* <tr>
                      <td className="print-w-70%">Item Master Basic Rate</td>
                      <td className="print-w-30%">{this.state.productDetails.itemMasterRate}</td>
                    </tr> */}
              </tbody>
            </table>
          </div>
          {/* 2 - Sections  */}
          <div className="item-sections min-w-[320px] max-w-[435px] mb-auto no-print flex flex-col" >
            <div className="search-grp flex gap-2">
              <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">
                Total RM+PM Amount
              </div>
              <input
                className="inputFocus w-[50%]"
                type="number"
                id="totalRmPm"
                name="totalRmPm"
                autoComplete="off"
                disabled
                value={this.state.productDetails.totalRmPm}
                onChange={(event) =>
                  this.handleChange(event, "totalRmpm", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-3 mt-[6px]">
              <div className="w-[50%]">
                <label>Prod. loss %</label>
                <input
                  className="inputFocus mr-1 w-full"
                  type="number"
                  id="prodLoss"
                  name="prodLoss"
                  autoComplete="off"
                  value={this.state.productDetails.prodLoss}
                  onChange={(event) =>
                    this.handleChange(event, "prodLoss", "productDetails")
                  }
                />
              </div>
              <input
                className="inputFocus w-[50%] mt-auto"
                type="number"
                id="calProdLoss"
                name="calProdLoss"
                disabled
                autoComplete="off"
                value={this.state.productDetails.calProdLoss}
                onChange={(event) =>
                  this.handleChange(event, "calProdLoss", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-2.5 mt-[8px]">
              <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">Total Batch Cost</div>
              <input
                className="inputFocus w-[50%]"
                type="number"
                id="toalBatchCost"
                name="totalBatchCost"
                disabled
                autoComplete="off"
                value={this.state.productDetails.totalBatchCost}
                onChange={(event) =>
                  this.handleChange(event, "totalBatchCost", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-2.5 mt-[8px]">
              <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">Per Unit Cost</div>
              <input
                className="inputFocus w-[50%]"
                type="number"
                id="perUnitCost"
                name="perUnitCost"
                disabled
                autoComplete="off"
                value={this.state.productDetails.perUnitCost}
                onChange={(event) =>
                  this.handleChange(event, "perUnitCost", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-2.5 mt-[8px]">
              <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">Mfg. Job Charges</div>
              <input
                className="inputFocus w-[50%]"
                type="number"
                id="jobCharges"
                name="jobCharges"
                disabled
                autoComplete="off"
                value={this.state.productDetails.jobCharges}
                onChange={(event) =>
                  this.handleChange(event, "jobCharges", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-3 mt-[6px]">
              <div className="w-[50%]">
                <label>Margin %</label>
                <input
                  className="inputFocus mr-1 w-full"
                  type="number"
                  id="margin"
                  name="margin"
                  autoComplete="off"
                  value={this.state.productDetails.margin}
                  onChange={(event) =>
                    this.handleChange(event, "margin", "productDetails")
                  }
                />
              </div>
              <input
                className="inputFocus w-[50%] mt-auto"
                type="number"
                id="calMargin"
                name="calMargin"
                disabled
                autoComplete="off"
                value={this.state.productDetails.calMargin}
                onChange={(event) =>
                  this.handleChange(event, "calMargin", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-2.5 mt-[8px]">
              <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">
                FP - Testing Charges
              </div>
              <input
                className="inputFocus w-[50%]"
                type="number"
                id="testingCharges"
                name="testingCharges"
                disabled
                autoComplete="off"
                value={this.state.productDetails.testingCharges}
                onChange={(event) =>
                  this.handleChange(event, "testingCharges", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-3 mt-[6px]">
              <div className="w-[50%]">
                <label>Other Charges %</label>
                <input
                  className="inputFocus mr-1 w-full"
                  type="number"
                  id="otherCharges"
                  name="otherCharges"
                  autoComplete="off"
                  value={this.state.productDetails.otherCharges}
                  onChange={(event) =>
                    this.handleChange(event, "otherCharges", "productDetails")
                  }
                />
              </div>
              <input
                className="inputFocus w-[50%] mt-auto"
                type="number"
                id="calOtherCharges"
                name="calOtherCharges"
                disabled
                autoComplete="off"
                value={this.state.productDetails.calOtherCharges}
                onChange={(event) =>
                  this.handleChange(event, "calOtherCharges", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-3 mt-2">
              <div className="w-[50%]">
                <label>Net Batch Cost</label>
                <input
                  className="inputFocus mr-1 w-full"
                  type="text"
                  id="netBatchCost"
                  name="netBatchCost"
                  disabled
                  autoComplete="off"
                  value={this.state.productDetails.netBatchCost}
                  onChange={(event) =>
                    this.handleChange(event, "netBatchCost", "productDetails")
                  }
                />
              </div>
              <input
                className="inputFocus w-[50%] mt-auto"
                type="number"
                id="calNetBatchCost"
                name="calNetBatchCost"
                disabled
                autoComplete="off"
                value={this.state.productDetails.calNetBatchCost}
                onChange={(event) =>
                  this.handleChange(event, "calNetBatchCost", "productDetails")
                }
              />
            </div>

            <div className="search-grp flex gap-2.5 mt-[8px]">
              <div className="w-[50%] flex items-center text-[14px] font-medium text-[#585858]">
                Item Master Basic Rate
              </div>
              <input
                className="inputFocus w-[50%]"
                type="number"
                id="itemMasterRate"
                name="itemMasterRate"
                disabled
                autoComplete="off"
                value={this.state.productDetails.itemMasterRate}
                onChange={(event) =>
                  this.handleChange(event, "itemMasterRate", "productDetails")
                }
              />
            </div>

            {/* <div className="flex">
              <button className="add-btn mt-3.5">Save</button>
            </div> */}


          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Product Costing Report</div>
                  </td>
                  <td>
                    <div className="hdr-meta">
                      Item Name: <strong>{this.state.productDetails.productName}</strong><br />
                      Batch Size: <strong>{this.state.productDetails.btSize}</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                                                      <div>
                                                        <span className="info-label">Item Name:</span>
                                                        <p className="info-value">Paracetamol</p>
                                                      </div>
                                                    </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "35%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>


              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Material Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Quantity
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Test
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.rmFormulaList &&
                  this.state.rmFormulaList.length > 0
                  ? this.state.rmFormulaList.map((item, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {item?.rmId?.rmName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.convertedQty}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.rmId?.rmUOM}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.purchaseRate}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.rmId?.testingCharge}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.totalAmount.toFixed(2)}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
              <tfoot>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <td colSpan="5" style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    R.M. Total
                  </td>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {this.state.productDetails.RMtotal}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="print-content">

            {/* <div className="info-row">
                                                      <div>
                                                        <span className="info-label">Item Name:</span>
                                                        <p className="info-value">Paracetamol</p>
                                                      </div>
                                                    </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "35%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>


              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Material Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Quantity
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    UOM
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Test
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.pmFormulaList &&
                  this.state.pmFormulaList.length > 0
                  ? this.state.pmFormulaList.map((item, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {item?.packageMaterialId?.pmName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.convertedQty}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.packageMaterialId?.pmUOM}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.purchaseRate}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.packageMaterialId?.pmTestingCharge}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {item.totalAmount.toFixed(2)}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
              <tfoot>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <td colSpan="5" style={{ textAlign: 'left', fontWeight: 'bold' }}>
                    P.M. Total
                  </td>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                    {this.state.productDetails.PMtotal}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div class="print-content total-section">
            <table class="total-tbl">
              <tbody>
                <tr>
                  <td class="total-label">Total RM+PM Amount</td>
                  <td class="total-value">{this.state.productDetails.totalRmPm}</td>
                </tr>
                <tr>
                  <td class="total-label">Prod. loss - <strong>({this.state.productDetails.prodLoss}%)</strong></td>
                  <td class="total-value">{this.state.productDetails.calProdLoss}</td>
                </tr>
                <tr>
                  <td class="total-label">Total Batch Cost</td>
                  <td class="total-value">{this.state.productDetails.totalBatchCost}</td>
                </tr>
                <tr>
                  <td class="total-label">Per Unit Cost</td>
                  <td class="total-value">{this.state.productDetails.perUnitCost}</td>
                </tr>
                <tr>
                  <td class="total-label">Mfg. Job Charges</td>
                  <td class="total-value">{this.state.productDetails.jobCharges}</td>
                </tr>
                <tr>
                  <td class="total-label">Margin - <strong>({this.state.productDetails.margin}%)</strong></td>
                  <td class="total-value">{this.state.productDetails.calMargin}</td>
                </tr>
                <tr>
                  <td class="total-label">FP - Testing Charges</td>
                  <td class="total-value">{this.state.productDetails.testingCharges}</td>
                </tr>
                <tr>
                  <td class="total-label">Other Charges - <strong>({this.state.productDetails.otherCharges}%)</strong></td>
                  <td class="total-value">{this.state.productDetails.calOtherCharges}</td>
                </tr>
                <tr class="grand-total-row">
                  <td class="total-label">Net Product Cost ({this.state.productDetails.netBatchCost})</td>
                  <td class="total-value">{this.state.productDetails.calNetBatchCost}</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductCostingReport;
